// This function allow to reference all chunks
__webpack_require__.hu = (chunkId) => {
	// return url for filenames based on template
	return "hot/" + chunkId + "." + __webpack_require__.h() + ".hot-update.js";
};